import { baseApi } from "./baseApi"

export interface SettingPatchResult {
  key: string
  value: unknown
  updated: true
}

export interface StaffAdmin {
  id: string
  email: string
  username: string
  createdAt?: string
}

export interface RolesPermissionsResult {
  roles: Array<{ id: string; name: string; createdAt?: string }>
  permissions: Array<{ id: string; name: string; createdAt?: string }>
}

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    patchSetting: build.mutation<SettingPatchResult, { key: string; value: unknown }>({
      query: ({ key, value }) => ({
        url: `/settings/${key}`,
        method: "PATCH",
        body: { value },
        adminApi: "v1",
      }),
      invalidatesTags: [{ type: "Setting", id: "LIST" }],
    }),
    getStaffAdmins: build.query<StaffAdmin[], void>({
      query: () => ({ url: "/settings/staff", adminApi: "v1" }),
      providesTags: [{ type: "Setting", id: "STAFF" }],
    }),
    getRolesPermissions: build.query<RolesPermissionsResult, void>({
      query: () => ({ url: "/settings/roles", adminApi: "v1" }),
      providesTags: [{ type: "Setting", id: "ROLES" }],
    }),
  }),
})

export const {
  usePatchSettingMutation,
  useGetStaffAdminsQuery,
  useGetRolesPermissionsQuery,
} = settingsApi
